import { createStore } from 'vuex';

import auth from './auth';
import labels from './labels';
import mortalin from './mortalin';

export default createStore({
  modules: {
    auth,
    mortalin,
    labels,
  }
});